import { render } from "./login.vue?vue&type=template&id=4e981f5e"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=4e981f5e&lang=postcss"
script.render = render

export default script